import "./Tabs.css";

const Tabs = ({ category, setCategory }) => {
  return (
    <div className="tabs">
      {["All", "Vodka", "Whiskey", "Rum", "Tequila"].map((tab) => (
        <button
          key={tab}
          className={category === tab ? "tab-active" : ""}
          onClick={() => setCategory(tab)}>
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
